import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take, map, Observable } from 'rxjs';
import { UserRole, hasMinRole } from './role.model';

export const roleGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const minRole = route.data['minRole'] as UserRole | undefined;
  const excludeRoles = route.data['excludeRoles'] as UserRole[] | undefined;

  return toObservable(authService.isAuthResolved).pipe(
    filter(resolved => resolved),
    take(1),
    map(() => {
      if (!authService.isAuthenticated()) {
        return router.createUrlTree(['/sign-in']);
      }

      const userRole = authService.userRole();
      if (userRole && excludeRoles?.includes(userRole)) {
        return router.createUrlTree(['/']);
      }

      if (!minRole) {
        return true;
      }

      if (hasMinRole(userRole, minRole)) {
        return true;
      }

      return router.createUrlTree(['/']);
    })
  );
};
